<div class="flex items-end justify-between mb-6">
  <div class="inline-block border-2 border-dashed border-gray-300 rounded-lg p-4 relative">
    <div class="absolute left-4 px-3 py-1 text-xl bg-[#faf7f3] -translate-y-1/2 top-0">
      Filters
    </div>

    <form [formGroup]="filterForm">
      <div class="flex flex-wrap gap-4">
        <mat-form-field appearance="fill" class="w-[300px] mr-12">
          <mat-label>Buildings</mat-label>
          <mat-select
            [multiple]="true"
            formControlName="selectedBuildingIds"
            (selectionChange)="onBuildingSelectionChange()">
            <mat-option (click)="toggleSelectAll($event)" [value]="-1">
              {{ isAllSelected() ? 'Unselect All' : 'Select All' }}
            </mat-option>

            @if (showUnassigned) {
              <mat-option [value]="0">Unassigned</mat-option>
            }

            @for (building of buildings; track building.id) {
              <mat-option [value]="building.id">
                {{ building.name }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="fill" class="w-[300px]">
          <mat-label>Search Users</mat-label>
          <input
            matInput
            formControlName="searchQuery"
            placeholder="Name or Email" />
        </mat-form-field>
      </div>
    </form>
  </div>

  <button
    class="text-2xl ml-4 self-end"
    [appIsAuthorizedForManagingCompany]="ManagingCompanyAuthorityType.MANAGING_COMPANY_ADMIN"
    [disabled]="!dialogBuildings?.length"
    data-cy="add-from-existing-users-button"
    mat-raised-button
    color="primary"
    (click) = "addOrUpdateUser()">
    <mat-icon>add</mat-icon>
    Add new from Existing Users
  </button>
</div>